import { render, staticRenderFns } from "./FaixaFronteira.vue?vue&type=template&id=9dc96a0e&lang=pug"
import script from "./FaixaFronteira.vue?vue&type=script&lang=js"
export * from "./FaixaFronteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports